angular.module('b2cApp.controllers').controller('ResultController', function ($scope, $http, $uibModal, $cookies) {
    var modalConfig = {
        backdropClass: 'show',
        keyboard: false,
        templateUrl: 'move-lead-nap-phone-modal.html.twig',
        windowClass: 'show',
        size: 'sm',
        windowTemplateUrl: 'modal-template-base.html',
        resolve: {
            phoneNumber: function () {
                return $scope.companyPhoneNumber;
            },
            trackingId: function () {
                return $scope.trackingId;
            },
            companyId: function () {
                return $scope.companyId;
            },
            leadUuid: function () {
                return $scope.leadUuid;
            }
        },
        controller: ['$scope', '$uibModalInstance', 'trackingId', 'companyId', 'leadUuid', function ($scope, $uibModalInstance, trackingId, companyId, leadUuid) {
            $scope.close = function () {
                $uibModalInstance.dismiss();
            };

            // The reveal button reports 'telephone_reveal'; this link is the only signal for an
            // actual dialled call, so it carries 'telephone'. ngClick does not preventDefault and
            // the dataLayer push is synchronous, so the tel: navigation is unaffected.
            $scope.trackCall = function () {
                window.GATracker.sendButtonClickEvent({
                    element_id: trackingId + '-telephone-call',
                    display_value: {contact_method: 'telephone', company_id: companyId},
                    lead: {lead_uuid: leadUuid}
                });
            };
        }]
    };

    $scope.loadedSelectedCompanies = false;
    $scope.noCompaniesFound = true;
    $scope.companyData = [];
    $scope.companyPhoneNumber = null;
    $scope.companiesNumberMatch = $cookies.get('companies_number_match');

    $scope.loadCompanyProfiles = function (companyHashesJson, companyProfileUrlParametersJson) {
        var processedCompanies = 0;

        var companyHashes = JSON.parse(companyHashesJson);
        var companyProfileUrlParameters = companyProfileUrlParametersJson ? JSON.parse(companyProfileUrlParametersJson) : {};

        if (companyHashes.length === 0) {
            $scope.loadedSelectedCompanies = true;
            $scope.noCompaniesFound = true;
        } else {
            angular.forEach(companyHashes, function (hash) {
                if (hash !== '') {
                    $scope.companyData.push(hash);
                    $http.get('/pro/' + hash + '/profile.json', {params: companyProfileUrlParameters}).then(function (response) {
                        if (typeof response !== 'undefined' && response.status === 200) {
                            var index = $scope.companyData.indexOf(response.data.hash);
                            $scope.companyData[index] = response.data;
                            $scope.companyData[index].trackingId = 'company-' + (index + 1) + '-' + companyHashes.length + '-' + response.data.hash
                        }
                    }).finally(function () {
                        processedCompanies++;
                        if (processedCompanies === companyHashes.length) {
                            $scope.loadedSelectedCompanies = true;

                            if ($scope.companyData.length > 0) {
                                $scope.noCompaniesFound = false;
                            }
                        }
                    });
                }
            });
        }
    };

    $scope.openPhoneModal = function (phoneNumber, trackingId, companyId, leadUuid) {
        $scope.companyPhoneNumber = phoneNumber;
        $scope.trackingId = trackingId;
        $scope.companyId = companyId;
        $scope.leadUuid = leadUuid;
        $uibModal.open(modalConfig);
    };

    $scope.getRating = function (rating) {
        if (!rating) {
            return 'company-rating-unknown';
        }
        if (rating <= 1.25) {
            return 'company-rating-very-bad';
        }
        if (rating <= 2.8) {
            return 'company-rating-bad';
        }
        if (rating <= 3) {
            return 'company-rating-medium';
        }
        if (rating <= 4) {
            return 'company-rating-good';
        }
        if (rating <= 5) {
            return 'company-rating-very-good';
        }
    };

    $scope.shouldShowSeeMoreAction = function (baseId) {
        const containerWidth = angular.element(`#${baseId}`).width();
        const textWidth = angular.element(`#${baseId}-text`).width();
        const linkWidth = angular.element(`#${baseId}-link`).width();
        return (parseInt((textWidth + linkWidth)) === parseInt(containerWidth));
    }

    $scope.expandLocations = function (baseId) {
        angular.element(`#${baseId}-text`).addClass('expanded');
        angular.element(`#${baseId}-link`).addClass('d-none');
    }
});
